import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Link } from 'react-router-dom'
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl'
import { signOut } from '../../common/auth/actions'
import { loadLessonDetail, clearLessonDetail } from '../../common/lessons/actions'
import { testTypes, exerciseTypes, roles } from '../../common/config'
import { showError } from '../../common/app/actions'
import { loadTestDetail, clearTestDetail, initTest, updateAnswers } from '../../common/tests/actions'
import { loadHomeworkDetail, clearHomeworkDetail } from '../../common/homeworks/actions'
import { setName, clearUser, savePractice } from '../../common/users/actions'
import { saveResult } from '../../common/results/actions'
import { NoDataFound, WordboxTest, TranslationTest, OptionsTest, OpenQuestionsTest,
  Keyboard, GuideMessage, Button, TextInput } from '../components'
import { TestSignUpForm , TestSignUpNameForm} from '../forms'
import getInputPosition from '../../common/lib/inputPosition'

class TestPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      testType: testTypes.EXAM,
      testStarted: false,
      openedWindow: false,

      activeLessonId: null,
      activeWordId: null,
      inputField: null,
      cursorIndex: 0,

      vocabularyLimitSet: false,
      practiceVocabularyLimit: 10,
    }
    this.lessonsComponents = {}
    this.onVisibilityChange = this.onVisibilityChange.bind(this)
    this.inputFocusHandler = this.inputFocusHandler.bind(this)
    this.setCursorIndex = this.setCursorIndex.bind(this)
    this.updateCursorIndex = this.updateCursorIndex.bind(this)
  }

  componentWillMount() {
    const { match, loadLessonDetail, loadTestDetail, loadHomeworkDetail } = this.props
    if (match.path.includes('practice')) {
      loadLessonDetail(match.params.id)
      this.setState({
        testType: testTypes.PRACTICE,
      })
    } else if (match.path.includes('sample-test')) {
      loadTestDetail(match.params.id)
      this.setState({
        testType: testTypes.SAMPLE,
      })
    } else if (match.path.includes('test')) {
      loadTestDetail(match.params.id)
    } else if (match.path.includes('homework')) {
      loadHomeworkDetail(match.params.id)
      this.setState({
        testType: testTypes.HOMEWORK,
      })
    }
  }

  componentDidMount() {
    this.props.initTest()

    document.addEventListener('keydown', this.setCursorIndex, false)
    document.addEventListener('click', () => {
      this.setState({
        cursorIndex: getInputPosition(this.state.inputField),
      })
    }, false)
  }

  componentWillUnmount() {
    this.props.clearLessonDetail()
    this.props.clearTestDetail()
    this.props.clearHomeworkDetail()
    this.props.clearUser()
  }

  setCursorIndex(e) {
    const keyCode = e.keyCode
    const { cursorIndex, inputField } = this.state
    if (keyCode === 37 && cursorIndex) {
      // left arrow
      this.setState({
        cursorIndex: getInputPosition(inputField) - 1,
      })
    } else if (keyCode === 39) {
      // right arrow
      this.setState({
        cursorIndex: getInputPosition(inputField) + 1,
      })
    }
  }

  updateCursorIndex() {
    this.setState({
      cursorIndex: getInputPosition(this.state.inputField),
    })
  }

  inputFocusHandler(e, activeLessonId, activeWordId) {
    this.setState({
      inputField: e.target,
      activeLessonId,
      activeWordId,
    })
  }

  onVisibilityChange(evt) {
    evt = evt || window.event
    if (evt.type !== 'focus') {
      this.setState({
        openedWindow: true,
      })
    }
  }

  addVisibilityListeners() {
    this.hidden = 'hidden'

    if (this.hidden in document) {
      document.addEventListener('visibilitychange', this.onVisibilityChange)
    } else if ('mozHidden' in document) {
      document.addEventListener('mozvisibilitychange', this.onVisibilityChange)
      this.hidden = 'mozHidden'
    } else if ('webkitHidden' in document) {
      document.addEventListener('webkitvisibilitychange', this.onVisibilityChange)
      this.hidden = 'webkitHidden'
    } else if ('msHidden' in document) {
      document.addEventListener('msvisibilitychange', this.onVisibilityChange)
      this.hidden = 'msHidden'
    } else if ('onfocusin' in document) {
      document.onfocusin = this.onVisibilityChange
      document.onfocusout = this.onVisibilityChange
    } else {
      window.onpageshow = this.onVisibilityChange
      window.onpagehide = this.onVisibilityChange
      window.onfocus = this.onVisibilityChange
      window.onblur = this.onVisibilityChange
    }

    // set the initial state (but only if browser supports the Page Visibility API)
    if (document[this.hidden] !== undefined) {
      this.onVisibilityChange({ type: document[this.hidden] ? 'blur' : 'focus' })
    }
  }

  goFullScreen() {
    this.setState({
      testStarted: true,
    })

    const element = document.getElementById('exam-page')
    if (element.requestFullscreen) element.requestFullscreen()
    else if (element.mozRequestFullScreen) element.mozRequestFullScreen()
    else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen()
    else if (element.msRequestFullscreen) element.msRequestFullscreen()
    this.addVisibilityListeners()
    
  }

  exitFullScreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen()
    }
  }

  checkAnswers() {
    const { saveResult, savePractice, currentUser, test, exam, currentHomework } = this.props
    const { testType } = this.state

    const lC = this.lessonsComponents
    Object.values(lC).forEach(c => {
      c.getWrappedInstance().checkAnswers()
    })

    let maxPoints = 0
    let points = 0

    const { lessons } = exam.toJS()

    Object.values(lessons).forEach(l => {
      points += l.points
      maxPoints += l.maxPoints
    })

    this.setState({
      activeWordId: null,
    })

    const exercises = Object.values(lessons)

    const result = {
      ...exam.toJS(),
      exercises,
      points,
      maxPoints,
      studentName: currentUser && currentUser.name,
      openedWindow: this.state.openedWindow,
    }
    if (testType === testTypes.EXAM) {
      saveResult({
        ...result,
        test: test && test.id,
        teacher: test.createdBy,
      })
    } else if (testType === testTypes.HOMEWORK && currentHomework) {
      saveResult({
        ...result,
        homework: currentHomework.id,
        teacher: currentHomework.createdBy,
      })
    } else if (testType === testTypes.PRACTICE) {
      savePractice({ 
        points,
        maxPoints,
       })
    }
    this.exitFullScreen()
  }

  render() {
    let { test } = this.props
    const { currentLesson, viewer, currentUser, intl, currentHomework,
      exam, updateAnswers, signOut, registeringUser, testLoadError, homeworkLoadError } = this.props
    const isPractice = this.state.testType === testTypes.PRACTICE
    const isSample = this.state.testType === testTypes.SAMPLE
    const isHomework = this.state.testType === testTypes.HOMEWORK
    const currentExam = (isPractice && !isSample) ? currentLesson : test || currentHomework
    const { activeWordId, activeLessonId, cursorIndex, vocabularyLimitSet, practiceVocabularyLimit } = this.state
    let studentForm = null

    if (isPractice && currentLesson) {
      test = {
        lessons: [currentLesson],
      }
    } else if (isHomework) {
      test = currentHomework
    }

    if (!test && (testLoadError || homeworkLoadError)) {
      return (
        <div className="flex-column-center test-page-error">
          <p>{intl.formatMessage(messages.wrongNumber)}</p>
          <Link to='/student-landing'>
            <Button>
              {intl.formatMessage(messages.enterNewNumber)}
            </Button>
          </Link>
        </div>
      )
    } 

    if (!test) return <span>Loading...</span>
    if (!currentExam || !currentExam.id) return <NoDataFound />

    let activeAnswer
    let lang

    if (activeWordId !== null) {
      activeAnswer = exam.lessons[activeLessonId].answers[activeWordId].userAnswer
      const lesson = isPractice ?
          currentLesson
        :
          (
            isHomework 
              ? test.lessons.find(l => String(l._id) === String(activeLessonId))
              : test.toJS().lessons.find(l => String(l._id) === String(activeLessonId))
          )
      lang = lesson.foreignLang
    }

    const isOwner = test.createdBy && viewer && test.createdBy.id === viewer.id

    const WarningMessage = (<p className="warning-msg">
      Po otvorení iného okna po spustení testu bude o tomto informovaný vyučujúci.</p>)

    if (!isPractice && !isSample && !viewer && !currentUser) {
      studentForm = (<form id="student-form" className="test-student-form">
        <h2 className="blue-title vertical-spacing">{test.name}</h2>
        {
          registeringUser ?
            <TestSignUpNameForm />
          :
            <TestSignUpForm />
        }
        
        {/*
        <Link to={`/sign-in?/${isHomework ? 'homework' : 'test'}/${test.testId || test.homeworkId}`}>
          <Button>
            {intl.formatMessage(messages.signIn)}
          </Button>
        </Link>
        <Link to={`/sign-up-form?/${isHomework ? 'homework' : 'test'}/${test.testId || test.homeworkId}`}>
          <Button>
            {intl.formatMessage(messages.signUp)}
          </Button>
        </Link>
        */}
      </form>)
    }

    if (!this.state.testStarted && !isPractice && !isSample && viewer) {
      studentForm = (<div className="test-logged-msg">
        {/*
          !isPractice && test.createdBy._id === viewer.id &&
          <GuideMessage text="Takto uvidí test žiak po prihlásení." />
        */}
        {/*
        {WarningMessage}
        */}
        <h2>
          {intl.formatMessage(messages.loggedInAs)}: {viewer.name}
        </h2>
        <div>
          <Link to="/student-landing">
            <Button>
              {intl.formatMessage(messages.home)}
            </Button>
          </Link>
          <Button onClick={() => signOut()}>
            {intl.formatMessage(messages.logOut)}
          </Button>
        </div>
        <Button
          big
          positive
          className="spacing-top"
          onClick={() => this.goFullScreen()}
        >
          {intl.formatMessage(isHomework ? messages.startHomework : messages.startTest)}
        </Button>
      </div>)
    }

    const student = viewer || currentUser

    const hasOpenQuestions = test.lessons.filter(l => l.type === exerciseTypes.OPEN_QUESTION).length > 0
    const openQuestionIndexes = test.lessons.map((l, idx) => {
      if (l.type === exerciseTypes.OPEN_QUESTION) {
        return idx + 1
      }
      return -1
    }).filter(val => val != -1)

    return (
      <div
        id="exam-page"
        className={isPractice ? '' : 'exam-page'}
      >
        <img className="exam-logo" src="/assets/images/elephant-logo.png" alt="Vobo" />
        {
          isSample ?
            (exam && exam.finished) ?
              <GuideMessage
                top
                text="Takto môže vyzerať aj Váš test. Výsledky budete mať okamžite po vyplnení žiakmi v aplikácii."
              />
            :
              <GuideMessage
                top
                text="Takto môže vyzerať aj Váš test."
              />
          :
            null
        }
        {
          studentForm ||
          <div className={(!isPractice || isSample) && 'exam-page-wrapper'}>
            <h2 className="blue-title vertical-spacing">
              {test && test.name}{!(isPractice || isSample) ? ` - ${student.name}` : ''}
            </h2>
            {
              test && exam && test.lessons.map((l, idx) => (
                <div key={l.id}>
                  {
                    l.type === exerciseTypes.OPEN_QUESTION &&
                    <OpenQuestionsTest
                      lesson={l}
                      answers={exam.lessons[l.id] && exam.lessons[l.id].answers}
                      inputFocusHandler={this.inputFocusHandler}
                      updateCursorIndex={this.updateCursorIndex}
                      points={exam.lessons[l.id] && exam.lessons[l.id].points}
                      maxPoints={exam.lessons[l.id] && exam.lessons[l.id].maxPoints}
                      lessonOrder={idx + 1}
                      showGradingNotice={exam.finished}
                      intl={intl}
                      ref={ref => {
                        this.lessonsComponents[l.id] = ref
                      }}
                    />
                  }
                  {
                    l.type === exerciseTypes.WORDBOX &&
                    <WordboxTest
                      lesson={l}
                      answers={exam.lessons[l.id] && exam.lessons[l.id].answers}
                      inputFocusHandler={this.inputFocusHandler}
                      updateCursorIndex={this.updateCursorIndex}
                      points={exam.lessons[l.id] && exam.lessons[l.id].points}
                      maxPoints={exam.lessons[l.id] && exam.lessons[l.id].maxPoints}
                      lessonOrder={idx + 1}
                      showResult={exam.finished}
                      intl={intl}
                      ref={ref => {
                        this.lessonsComponents[l.id] = ref
                      }}
                    />
                  }
                  {
                    l.type === exerciseTypes.TRANSLATION && (
                      (!vocabularyLimitSet && isPractice) ? 
                        <div className="row-content-centered">
                          <TextInput
                            onChange={e => this.setState({ practiceVocabularyLimit: Number(e.target.value) })}
                            value={practiceVocabularyLimit}
                          />
                          <Button
                            onClick={() => this.setState({ vocabularyLimitSet: true })}
                            positive
                            big
                          >
                            {intl.formatMessage(messages.startTest)}
                          </Button>
                        </div>
                        :
                        <TranslationTest
                          lesson={l}
                          answers={exam.lessons[l.id] && exam.lessons[l.id].answers}
                          inputFocusHandler={this.inputFocusHandler}
                          updateCursorIndex={this.updateCursorIndex}
                          points={exam.lessons[l.id] && exam.lessons[l.id].points}
                          maxPoints={exam.lessons[l.id] && exam.lessons[l.id].maxPoints}
                          lessonOrder={idx + 1}
                          practiceVocabularyLimit={practiceVocabularyLimit}
                          vocabularyLimitSet={vocabularyLimitSet}
                          showResult={exam.finished}
                          intl={intl}
                          ref={ref => {
                            this.lessonsComponents[l.id] = ref
                          }}
                        />
                    )
                  }
                  {
                    l.type === exerciseTypes.OPTIONS &&
                    <OptionsTest
                      lesson={l}
                      answers={exam.lessons[l.id] && exam.lessons[l.id].answers}
                      inputFocusHandler={this.inputFocusHandler}
                      updateCursorIndex={this.updateCursorIndex}
                      points={exam.lessons[l.id] && exam.lessons[l.id].points}
                      maxPoints={exam.lessons[l.id] && exam.lessons[l.id].maxPoints}
                      lessonOrder={idx + 1}
                      showResult={exam.finished}
                      intl={intl}
                      ref={ref => {
                        this.lessonsComponents[l.id] = ref
                      }}
                    />
                  }
                </div>
              ))
            }
            {
              (exam && exam.finished) ?
                <div>
                  <p className="vertical-spacing large-text">
                    {intl.formatMessage(messages.points)}: {exam.points}/{exam.maxPoints}
                  </p>
                  {
                    hasOpenQuestions &&
                    <p className="vertical-spacing large-text">
                      <FormattedMessage
                        { ...messages.openQuestionGradingNotice }
                        values={{ openQuestionIndexes: openQuestionIndexes }}
                      />
                    </p>
                  }
                  {isPractice &&
                    <div className="block-center">
                      <Button big positive onClick={() => window.location.reload()}>
                        {intl.formatMessage(messages.tryAgain)}
                      </Button>
                    </div>
                  }
                  {isSample &&
                    <div className="block-center">
                      <Link to="/sign-up-form">
                        <Button big positive>
                          {intl.formatMessage(messages.createOwnTest)}
                        </Button>
                      </Link>
                    </div>}
                  {isOwner &&
                    <div className="block-center">
                      <Link to={`/app/${isHomework ? 'homework': 'test'}/${test.id}`}>
                        <Button big positive>
                          {intl.formatMessage(messages.backToDetail)}
                        </Button>
                      </Link>
                    </div>}
                  {(!isSample && !isPractice && !isOwner) &&
                    <div className="block-center">
                      {
                        viewer.role === roles.USER &&
                        <Link to="/student-landing">
                          <Button>
                            {intl.formatMessage(messages.home)}
                          </Button>
                        </Link>
                      }
                      <Link to="/sign-out">
                        <Button big positive>
                          {intl.formatMessage(messages.logOut)}
                        </Button>
                      </Link>
                    </div>}
                </div>
              :
                (!isPractice || vocabularyLimitSet) &&
                <div className="block-center vertical-spacing test-send-wrapper">
                  <Button
                    big
                    positive
                    onClick={() => this.checkAnswers()}
                  >
                    {(isPractice || isSample) ?
                      intl.formatMessage(messages.continue)
                    :
                      intl.formatMessage(messages.send)
                    }
                  </Button>
                </div>
            }
          </div>
        }
        {
          activeWordId !== null &&
          <Keyboard
            lessonId={activeLessonId}
            lang={lang}
            wordId={activeWordId}
            word={activeAnswer}
            cursorIndex={cursorIndex}
            textChange={updateAnswers}
          />
        }
      </div>
    )
  }
}

TestPage.defaultProps = {
  currentLesson: {},
  match: {},
  test: null,
  viewer: null,
  currentUser: null,
  currentHomework: null,
  exam: null,
}

TestPage.propTypes = {
  intl: PropTypes.object.isRequired,
  loadLessonDetail: PropTypes.func.isRequired,
  clearLessonDetail: PropTypes.func.isRequired,
  loadHomeworkDetail: PropTypes.func.isRequired,
  clearHomeworkDetail: PropTypes.func.isRequired,
  loadTestDetail: PropTypes.func.isRequired,
  clearTestDetail: PropTypes.func.isRequired,
  saveResult: PropTypes.func.isRequired,
  clearUser: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired,
  initTest: PropTypes.func.isRequired,
  updateAnswers: PropTypes.func.isRequired,
  savePractice: PropTypes.func.isRequired,
  exam: PropTypes.object,
  currentHomework: PropTypes.object,
  currentLesson: PropTypes.object,
  match: PropTypes.object,
  test: PropTypes.object,
  viewer: PropTypes.object,
  currentUser: PropTypes.object,
  registeringUser: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    lessons: state.lessons.all,
    currentLesson: state.lessons.currentLesson,
    currentHomework: state.homeworks.currentHomework,
    test: state.tests.currentTest,
    exam: state.tests.exam,
    viewer: state.users.viewer,
    currentUser: state.users.current,
    registeringUser: state.users.registeringUser,
    testLoadError: state.tests.testLoadError,
    homeworkLoadError: state.homeworks.homeworkLoadError,
  }), {
    loadLessonDetail,
    clearLessonDetail,
    loadHomeworkDetail,
    clearHomeworkDetail,
    saveResult,
    loadTestDetail,
    clearTestDetail,
    setName,
    clearUser,
    initTest,
    updateAnswers,
    showError,
    signOut,
    savePractice,
  }),
  injectIntl,
)

export default enhance(TestPage)

const messages = defineMessages({
  loggedInAs: {
    id: 'test.page.loggedInAs',
    defaultMessage: 'Ste prihlásený ako',
  },
  signIn: {
    id: 'test.page.signIn',
    defaultMessage: 'Prihlásiť sa',
  },
  signUp: {
    id: 'test.page.signUp',
    defaultMessage: 'Registrovať',
  },
  logOut: {
    id: 'test.page.logOut',
    defaultMessage: 'Odhlásiť',
  },
  startTest: {
    id: 'test.page.startTest',
    defaultMessage: 'Spustiť test',
  },
  startHomework: {
    id: 'test.page.startHomework',
    defaultMessage: 'Spustiť úlohu',
  },
  points: {
    id: 'test.page.points',
    defaultMessage: 'Body',
  },
  tryAgain: {
    id: 'test.page.tryAgain',
    defaultMessage: 'Skúsiť znovu',
  },
  continue: {
    id: 'test.page.continue',
    defaultMessage: 'Pokračovať',
  },
  send: {
    id: 'test.page.send',
    defaultMessage: 'Odoslať',
  },
  createOwnTest: {
    id: 'test.page.createOwnTest',
    defaultMessage: 'Vytvoriť vlastný test',
  },
  backToDetail: {
    id: 'test.page.backToDetail',
    defaultMessage: 'Späť na detail testu',
  },
  openQuestionGradingNotice: {
    id: 'test.page.openQuestionGradingNotice',
    defaultMessage: 'Body za cvičenia číslo {openQuestionIndexes} budú udelené učiteľom.',
  },
  wrongNumber: {
    id: 'test.page.wrongNumber',
    defaultMessage: 'Tento test alebo úloha neexistuje',
  },
  enterNewNumber: {
    id: 'test.page.enterNewNumber',
    defaultMessage: 'Zadaj iné číslo',
  },
  home: {
    id: 'test.page.home',
    defaultMessage: 'Domov',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/TestPage.js